import { CashFund, TransactionDestinationType, TransactionSourceType } from "../../../state/types"
import { useCashFundActions } from "../../../actions/cashFundActions"
import { Emitter, Event } from "../../../../../features/event-emitter"
import { Data } from "../../../../../features/ui"
import { define } from "../../../../../utils/typeUtils"

export const useActions = () => {
    const { transferMoney } = useCashFundActions()

    const updateCashFundAmount = async (
        cashFund: CashFund,
        data: Data,
        concept: string,
        addMode: boolean
    ) => {
        Emitter.emit(Event.DB_SUBMIT)

        const sourceType = addMode ? TransactionSourceType.MANUAL_ADDITION : TransactionSourceType.CASH_FUND
        const sourceId = !addMode ? cashFund.id : undefined
        const amount = define(data.amount) as number
        const destinationType = addMode ? TransactionDestinationType.CASH_FUND : TransactionDestinationType.MANUAL_SUBSTRACTION
        const destinationId = addMode ? cashFund.id : undefined
        await transferMoney(sourceType, destinationType, amount, sourceId, destinationId, new Date(), false, concept)

        Emitter.emit(Event.DB_SUBMIT_DONE, false)
    }
    
    return {
        updateCashFundAmount
    }
}
